module.exports = {"id":"218970","name":"Firmin Ndombe Mubele","rating":"74","photo":"./data/images/photos/2/218970.png","club":{"name":"Toulouse FC","logo":"./data/images/clubs/ToulouseFC.png"},"positions":["BU","AD","AG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FirminNdombeMubele0.json
// module id = 1442
// module chunks = 0